import type { IdentifyPersonConfig } from '@/types/custom-playbooks';

/** What a fresh Identify person step saves; equal to the server's
 * `play_identify_person.DEFAULT_CONFIG`: no options. */
export const IDENTIFY_PERSON_DEFAULT_CONFIG: IdentifyPersonConfig = {};

/** The only key the step takes: the delay every step shares. */
const KEYS = new Set(['delay']);

/**
 * Why an Identify person step can't turn On yet, mirroring the server's
 * `play_identify_person.validate_config`: it takes no options, so a key it
 * doesn't know is the only way it is incomplete. Null when it is complete.
 */
export function identifyPersonConfigError(
  config: Partial<IdentifyPersonConfig> | undefined
): string | null {
  if (!config || typeof config !== 'object' || Array.isArray(config))
    return 'Set up Identify person.';
  const extra = Object.keys(config)
    .filter((key) => !KEYS.has(key))
    .sort();
  if (extra.length) return `Identify person doesn't take ${extra.join(', ')}.`;
  return null;
}

/** The card line, as the server writes it
 * (`play_identify_person.step_summary`). */
export function identifyPersonSummary(): string {
  return 'LinkedIn URL, work email, then name searches';
}
